export default __webpack_public_path__ + "static/media/logo.2c417bdb.png";